/** Confirmation native avant une action destructive. Centralise le message pour
 * une expérience cohérente (cf. FoodsPage qui confirmait déjà ses suppressions). */
export function confirmDelete(what: string): boolean {
  return window.confirm(`Supprimer ${what} ? Cette action est définitive.`);
}
